import {
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { DcrCheckboxInterface } from '@diekeure/dcr-components';
import '@diekeure/dcr-components/dcr-checkbox.js';
import '@diekeure/dcr-components/dcr-inline-icon-button.js';
import { Observable, Subscription } from 'rxjs';
import { CookiesServiceInterface, COOKIES_SERVICE_TOKEN } from './services/cookies';

@Component({
  standalone: false,
  selector: 'campus-cookies-content',
  templateUrl: './cookies-content.component.html',
  styleUrls: ['./cookies-content.component.scss'],
})
export class CookiesContentComponent implements OnInit, OnDestroy, OnChanges {
  public cookieStatus: 'minimal' | 'current' | 'all';
  public cookies$: Observable<object>;
  @HostBinding('class.visible') public visible: boolean;
  private subscriptions = new Subscription();
  @Input() linkcookies: string;
  @Input() linkCookiesLabel = 'hier';
  @Input() setVisible?: boolean;
  @Input() errormessage?: string;
  @Output() close?: EventEmitter<boolean> = new EventEmitter();
  constructor(
    @Inject(COOKIES_SERVICE_TOKEN)
    private cookiesService: CookiesServiceInterface
  ) {}

  ngOnInit() {
    if (this.cookiesService.isLocalStorageEmpty()) {
      this.visible = true;
    }

    this.cookiesService.setInitialConsentValues();
    this.cookies$ = this.cookiesService.cookies$;

    this.subscriptions.add(
      this.cookies$.subscribe((cookies) => {
        this.cookieStatus = this.getCookieStatus(cookies);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.setVisible) {
      this.visible = this.setVisible;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public setConsentValue(label: string, event: InputEvent) {
    this.cookiesService.setConsentValue(label, (event.target as DcrCheckboxInterface).checked);
  }

  public setCookies(status = this.cookieStatus) {
    if (status === 'all') {
      this.cookiesService.setAllConsentValues(true);
    } else if (status === 'minimal') {
      this.cookiesService.setAllConsentValues(false);
    }
    this.cookiesService.saveConsentValues();
    window.location.reload();
    this.clearElement();
  }

  public clearElement() {
    this.visible = false;
    this.setVisible = false;
    this.errormessage = '';
    this.close.emit(true);
  }

  private getCookieStatus(cookies) {
    return Object.values(cookies).some((value) => value === true) ? 'current' : 'all';
  }
}
